import type { AgentSessionSource } from "./types";

/** The user-role row that resumes a session after the sub-session it spawned settles. */
export function isMonitorWakeMessage(message: {
  role: string;
  originSource?: AgentSessionSource;
}): boolean {
  return message.role === "user" && message.originSource === "monitor";
}
